import queryString from "query-string";
import { GET_COACHING, GET_COACHING_BY_COMPETENCY } from "@/api/master-data/coaching/coaching";

const state = {
    coaching: [],
};
const mutations = {
    setCoaching: (states, payload) => {
        states.coaching = payload;
    },

};
const actions = {
    getCoaching: async ({ commit }, args = {}) => {
        try {
            const resp = await GET_COACHING(args);
            if (resp.data.httpCode === 200) {
                commit("setCoaching", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCoaching", []);
            }
            throw err;
        }
    },
    getCoachingByCompetency: async ({ commit }, { competencyId, args = {} }) => {
        try {
            const resp = await GET_COACHING_BY_COMPETENCY(competencyId, args);
            if (resp.data.httpCode === 200) {
                commit("setCoaching", resp.data);
                return resp.data;
            }
        } catch (err) {
            const resp = err.response;
            if (resp.data.httpCode === 404) {
                commit("setCoaching", []);
            }
            throw err;
        }
    },
};

const getters = {
    trainingProviders: (states) => states.trainingProviders,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
